import BaseModel from "./Abstracts/BaseModel";
import Question from "./Question";

export default class Quiz extends BaseModel{
    constructor(data) {
        super()
        this.$dirty = false
        this.id = null
        this.name = ''
        this.completeText = ''
        this.defaultCorrectDisplayText = ''
        this.defaultIncorrectDisplayText = ''

        this.urls = {
            edit: "",
            update: "",
            view: "",
            create: "",
            addQuestion: "",
            saveQuestionPositions: "",
            delete: ""
        }
        this.questions = {
            data: []
        }
        this.tokens = {
            update: '',
            addQuestion: '',
            delete: '',
            saveQuestionPositions: ''
        }

        this.setData(data)
        this.setInitialized()
    }

    getOptionsFormData() {
        const formData = new FormData()
        formData.append('name', this.name)
        formData.append('completeText', this.completeText)
        formData.append('defaultCorrectDisplayText', this.defaultCorrectDisplayText)
        formData.append('defaultIncorrectDisplayText', this.defaultIncorrectDisplayText)
        return formData
    }
    
    setData(data) {
        // when we're setting data we want to create objects out of any questions
        // which are passed along instead of just hashes
        let questions = []
        if (data?.hasOwnProperty('questions')) {
            for (const question of data.questions.data) {
                questions.push(new Question(question));
            }
           data.questions.data = questions
        }
        super.setData(data)
    }
}
